import { render, staticRenderFns } from "./index.vue?vue&type=template&id=17223b52"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17223b52')) {
      api.createRecord('17223b52', component.options)
    } else {
      api.reload('17223b52', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=17223b52", function () {
      api.rerender('17223b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/CookieConsent/index.vue"
export default component.exports